import React from "react";
import { CircularProgress } from "@mui/material";

export default ({ classNameOverride }) => (
  <div className={`h-full flex justify-center items-center py-8 px-8 ${classNameOverride}`}>
    <CircularProgress color="primary" size={60} />
  </div>
);
